import { atom } from 'recoil';

export const exchangeRateState = atom({
  key: 'exchangeRateAtom',
  default: [],
})